import * as req from 'api/actions';
import * as c from './constant';


export const getCovidVaccineRegList = (
  payload = { module_type: 'EHELP' },
  callback
) =>
  req.list(
    c.GET_REGISTRATION,
    'api/v1/administrators/ehelp/covid_vaccine_registrations',
    payload,
    callback
  );

export const showRegistration = (id, payload, callback) =>
req.item(
  c.SHOW_REGISTRATION,
  // `api/v1/administrators/ehelp/covid_vaccine_registrations/1`,
  `api/v1/administrators/ehelp/covid_vaccine_registrations/${id}`,
  payload,
  callback
);

export const clearRegistration = () => req.setList(c.GET_REGISTRATION, []);